import { useState, useEffect, useCallback, useMemo } from "react";
import { SimpleGrid, FormLabel } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Loading from "../../../Component/Loading/loading";
import apiService from "../../../Method/Report/Report_Service";
import { ThemeProvider } from "@mui/material/styles";
import TableWidget from "../../../Component/Table/TableWidget";
import theme from "../../../assets/Table/TableTheme";
import { t } from "i18next";
import { useDataContext } from "../../../DataProvider";

const buildColumns = () => [
  {
    name: "ITEM_NAME",
    label: t("ITEM_NAME"),
    options: { filter: false, sort: false },
  },
  {
    name: "QTY_IN",
    label: t("QTY_IN"),
    options: {
      filter: false, sort: false,
      search: false,
      customBodyRender: (value) => {
        return value ? value.toLocaleString() : "0";
      },
    },
  },
  {
    name: "QTY_OUT",
    label: t("QTY_OUT"),
    options: {
      filter: false,
      sort: false,
      search: false,
      customBodyRender: (value) => {
        return value ? value.toLocaleString() : "0";
      },
    },
  },
  {
    name: "QTY_REMAIN",
    label: t("QTY_REMAIN"),
    options: {
      filter: false,
      sort: false,
      search: false,
      customBodyRender: (value) => {
        return value ? value.toLocaleString() : "0";
      },
    },
  },

];

function App() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const { trigger } = useDataContext();
  const [searchText, setSearchText] = useState("");


  const columns = useMemo(() => buildColumns(t), [t]);
  const [searchColumns, setSearchColumns] = useState(() =>
    columns.filter((c) => c.options?.search !== false).map((c) => c.name)
  );
  useEffect(() => {
    setSearchColumns(columns.filter((c) => c.options?.search !== false).map((c) => c.name));
  }, [columns]);

  const fetchData = useCallback(async () => {

    setLoading(true);
    const { success, data, error } = await apiService.search("GET_ITEM_STORE_SALES_REPORT", page + 1, rowsPerPage);

    if (success && data) {
      setLoading(false);
      setData(data);
      setTotalCount(data.TOTAL_COUNT || 0);

      setError("")
    } else {
      setError(error.response.data.message);
      setLoading(false);
    }

  }, [page, rowsPerPage]);

  useEffect(() => {
    fetchData()
  }, [trigger, fetchData]);


  const filteredData = (data?.ITEM_DETAILS || []).filter((row) => {
    const q = (searchText || "").toLowerCase().trim();
    if (!q) return true;
    return searchColumns.some((name) =>
      row?.[name]?.toString().toLowerCase().includes(q)
    );
  });
  return (
    <ThemeProvider theme={theme}>


      {error && <p className="error-message">{error}</p>}
      {isLoading && <Loading />}
      <div>
        {!isLoading && (
          <div style={{ width: "100%", overflowX: "auto", marginTop: "10px" }}>
            <SimpleGrid
              className="Total_Header"

              columns={{ base: 1, md: 3 }}
            >
              <div>
                <FormLabel className="Total_Header_Right" >
                  {t("TOTAL_QTY_IN")}
                </FormLabel>
                <FormLabel
                  className="Total_Header_Value"

                >
                  {data.ALL_QTY_IN ? data.ALL_QTY_IN.toLocaleString() : "0"}
                </FormLabel>
              </div>
              <div>
                <FormLabel className="Total_Headers" >
                  {t("TOTAL_QTY_OUT")}
                </FormLabel>
                <FormLabel
                  className="Total_Header_Value"

                >
                  {data.ALL_QTY_OUT ? data.ALL_QTY_OUT.toLocaleString() : "0"}
                </FormLabel>
              </div>
              <div>
                <FormLabel className="Total_Header_Left" >
                  {t("TOTAL_QTY_REMAIN")}
                </FormLabel>
                <FormLabel
                  className="Total_Header_Value"

                >
                  {data.ALL_QTY_REMAIN ? data.ALL_QTY_REMAIN.toLocaleString() : "0"}
                </FormLabel>
              </div>
            </SimpleGrid>
            <TableWidget
              title={t("ITEM_STORE_Report")}
              data={filteredData}
              onSearchChange={setSearchText}
              columns={columns}
              totalCount={totalCount}
              page={page}
              rowsPerPage={rowsPerPage}
              onPageChange={setPage}
              onRowsPerPageChange={setRowsPerPage}
              searchColumns={searchColumns}
              setSearchColumns={setSearchColumns}
            />
          </div>
        )}
      </div>
    </ThemeProvider >
  );
}

export default App;
